<template>
  <div>
    <div class="custom-card">
      <el-tooltip :content="customizedData.title" placement="top-end">
        <div class="custom-card-title">{{ customizedData.title }}</div>
      </el-tooltip>
      <div class="custom-card-pseudo"></div>
      <div class="custom-card-line"></div>
      <el-tooltip :popper-class="hidContentTips" :content="customizedData.content" placement="top-end">
        <div :id="contentId" class="custom-card-content">
          {{ customizedData.content }}
        </div>
      </el-tooltip>
      <div class="custom-card-info">
        <el-form>
          <el-form-item label="客户公司：">
            <el-tooltip :popper-class="hidCompanyTips" :content="customizedData.info.company" placement="top-end">
              <p :id="contextCompanyId" class="card-info-context">{{ customizedData.info.company }}</p>
            </el-tooltip>
          </el-form-item>
          <el-form-item label="承接部门：">
            <el-tooltip :popper-class="hidDepartmentTips" :content="customizedData.info.department" placement="top-end">
              <p :id="contextDepartmentId" class="card-info-context">{{ customizedData.info.department }}</p>
            </el-tooltip>
          </el-form-item>
          <el-form-item label="承接人员：">
            <el-tooltip :popper-class="hidPersonnelTips" :content="customizedData.info.personnel" placement="top-end">
              <p :id="contextPersonnelId" class="card-info-context">{{ customizedData.info.personnel }}</p>
            </el-tooltip>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    customizedData: {
      default: () => {},
      type: Object,
    }
  },
  data() {
    return {
      contentId: `header-content${Math.random()}`,
      contextCompanyId: `header-content${Math.random()}`,
      contextDepartmentId: `header-content${Math.random()}`,
      contextPersonnelId: `header-content${Math.random()}`,
      hidContentTips: '',
      hidCompanyTips: '',
      hidDepartmentTips: '',
      hidPersonnelTips: '',
    }
  },
  mounted() {
    this.getInfopopOver(this.contextCompanyId, 1)
    this.getInfopopOver(this.contextDepartmentId, 2)
    this.getInfopopOver(this.contextPersonnelId, 3)
    this.getContentpopOver()
  },
  methods: {
    getContentpopOver() {
      const cell = document.getElementById(this.contentId)
      if (cell.scrollHeight > 72) {
        this.hidContentTips = ''
      } else {
        this.hidContentTips = 'hidden-customized-card-tips'
      }
    },
    getInfopopOver(id, type) {
      const cell = document.getElementById(id)
      if (cell.scrollHeight > 32) {
        this.hidCompanyTips = ''
        this.hidDepartmentTips = ''
        this.hidPersonnelTips = ''
      } else {
        switch (type) {
          case 1:
            this.hidCompanyTips = 'hidden-customized-card-tips'
            break
          case 2:
            console.log('cell.scrollHeight', cell.scrollHeight)
            this.hidDepartmentTips = 'hidden-customized-card-tips'
            break
          case 3:
            this.hidPersonnelTips = 'hidden-customized-card-tips'
            break
          default:
            break
        }
      }
    },
  },
}
</script>

<style lang="scss">
@import "~@/assets/styles/mixin.scss";
.custom-card {
  width: 270px;
  height: 223px;
  background: linear-gradient(150.31deg, rgba(249,250,255,1) 0%,rgba(241,245,255,1) 100%);
  border-radius: 8px 24px 14px 8px;
  display: inline-block;
  vertical-align: bottom;
  position: relative;
  box-sizing: border-box;
  padding: 16px;

  .custom-card-title {
    color: #3C6EF0;
    font-size: 18px;
    @include font-family-jd;
    font-weight: normal;
    cursor: pointer;
  }
  .custom-card-pseudo {
    width: 17px;
    height: 17px;
    position: absolute;
    top: 0;
    right: 0;
    // border-radius: 4px 0px 4px 0;
    // background-color: red;
    &:before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: linear-gradient(to bottom left,  white 50%, transparent 50%);
      mask-image: linear-gradient(to bottom left, black 50%, transparent 50%); /* 使用黑色作为遮罩，以确保右上角透明 */
      -webkit-mask-image: linear-gradient(to bottom left, black 50%,  transparent 50%); /* 对于不支持mask-image的浏览器，使用-webkit-前缀 */
    }
  }
  .custom-card-line {
    width: 100%;
    height: 1px;
    border: 1px solid;
    border-image: linear-gradient(180deg, rgba(230,232,241,1) 0%,rgba(228,229,233,1) 100%) 1 1;
    margin: 10px 0;

  }
  .custom-card-content {
    // min-height: 72px;
    color: #23252B;
    line-height: 18px;
    margin-bottom: 8px;
    white-space: pre-line;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 4;
    overflow: hidden;
    word-break: break-all;
    text-overflow: ellipsis;
    cursor: pointer;
  }
  .custom-card-info {
    .el-form-item {
      margin-bottom: 0px;
      word-break: break-all;
      max-width: 238px;
      cursor: pointer;
      .el-form-item__label, .el-form-item__content {
        font-size: 10px;
        line-height: 16px;
        padding: 0;
      }
      .card-info-context {
        color: #525765;
        white-space: pre-line;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
        word-break: break-all;
        text-overflow: ellipsis;
      }
    }
  }
}
</style>
<style lang="scss">
.hidden-customized-card-tips {
  display: none;
}
</style>
